import 'twin.macro';
import { SidebarTeacher } from '@teetsh/app/src/containers/Sidebar/SidebarTeacher';
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { ErrorPage } from '@teetsh/app/src/components/ErrorPage';
import { HeaderComponent } from '@teetsh/app/src/containers/Header';
import { queryClient } from '@teetsh/app/src/queryClient';
import { loader as userLoader } from '@teetsh/app/src/queries/user/useUser';
import { SchoolyearProviderWrapper } from '@teetsh/app/src/containers/App/AutenticatedApp/SchoolyearsDependentRoutes';
import { SchoolyearsBreadcrumb } from '@teetsh/app/src/containers/App/Breadcrumb';
import { useAuth } from '@teetsh/app/src/containers/App/context/AuthContext';
import {
  FicheDePrepRoutes,
  FicheDePrepNewRoutes,
  SequencePreviewRoutes,
  SequenceRoutes,
} from '@teetsh/app/src/containers/Sequences/routes';
import { UserSettingsRoutes } from '@teetsh/app/src/containers/UserSettings/routes';
import { PrintRoutes } from '@teetsh/app/src/containers/printRoutes';
import { EmploiDuTempsRoutes } from '@teetsh/app/src/containers/EmploiDuTemps/routes';
import { LivretsRoutes } from '@teetsh/app/src/containers/Livrets/routes';
import { CarnetsDeNotesRoutes } from '@teetsh/app/src/containers/CarnetsDeNotes/routes';
import { BudgetsRoutes } from '@teetsh/app/src/containers/Budgets/routes';
import { PlannerRoutes } from '@teetsh/app/src/containers/Planner/routes';
import { CahierJournalRoutes } from '@teetsh/app/src/containers/CahierJournal/routes';
import { RegistreAppelRoutes } from '@teetsh/app/src/containers/RegistreAppel/routes';
import { PyramidesDesAgesRoutes } from '@teetsh/app/src/containers/PyramidesDesAges/routes';
import {
  ElevesPreviewRoutes,
  ElevesRoutes,
} from '@teetsh/app/src/containers/Eleves/routes';
import { TrombinoscopeRoutes } from '@teetsh/app/src/containers/Trombinoscope/routes';
import { ProgrammationRoutes } from '@teetsh/app/src/containers/Programmations/routes';
import { DashboardRoutes } from '@teetsh/app/src/containers/Dashboard/routes';
import { PricingRoutes } from '@teetsh/app/src/containers/Pricing/routes';
import { RedirectRoutes } from '@teetsh/app/src/redirectRoutes';
import { MesAnneesScolairesRoutes } from '@teetsh/app/src/containers/MesAnneesScolaires/routes';
import { ShareRoutes } from '@teetsh/app/src/containers/shareRoutes';
import App from '@teetsh/app/src/App';
import ResetTrialPage from '@teetsh/app/src/containers/OneOffPages/ResetTrial/Loadable';
import AutoPrintFicheDePrep from '@teetsh/app/src/containers/Sequences/LoadableAutoPrintFicheDePrep';
import ShareSchoolAccept from '@teetsh/app/src/containers/MesAnneesScolaires/ShareAccept/Loadable';
import BlockedPage from '@teetsh/app/src/containers/UserSettings/Blocked/Loadable';
import AutoPrintSequence from '@teetsh/app/src/containers/Sequences/LoadableAutoPrintSequence';

function WithSidebar() {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to={'/login'} />;
  }

  if (user.blockedAt) {
    return <Navigate to={'/blocked'} />;
  }

  return (
    <div tw="flex h-screen">
      <SidebarTeacher />
      <div tw="relative flex-1 overflow-y-auto overflow-x-hidden h-full">
        <div tw="flex flex-col flex-1 h-full">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export const teacherRoutes = [
  {
    path: '/',
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      {
        loader: userLoader(queryClient),
        children: [
          ...PricingRoutes,
          {
            path: 'blocked',
            element: <BlockedPage />,
          },
          {
            element: <WithSidebar />,
            children: [
              FicheDePrepRoutes,
              FicheDePrepNewRoutes,
              SequenceRoutes,
              SequencePreviewRoutes,
              {
                path: 'reset-trial',
                element: (
                  <>
                    <HeaderComponent />
                    <ResetTrialPage />
                  </>
                ),
              },
              UserSettingsRoutes,
              MesAnneesScolairesRoutes,
              {
                path: 'annee-scolaire/:schoolyearId/ecole/:schoolId/share/accept', // keep this path for backward compatibility
                element: <ShareSchoolAccept />,
              },
              {
                path: 'ecole/:schoolId/share/accept',
                element: <ShareSchoolAccept />,
              },
              {
                path: 'annee-scolaire/:schoolyearId/ecole/:schoolId',
                element: (
                  <SchoolyearProviderWrapper>
                    <HeaderComponent withSubHeader>
                      <SchoolyearsBreadcrumb />
                    </HeaderComponent>
                    <Outlet />
                  </SchoolyearProviderWrapper>
                ),
                children: [
                  DashboardRoutes,
                  EmploiDuTempsRoutes,
                  CahierJournalRoutes,
                  ProgrammationRoutes,
                  CarnetsDeNotesRoutes,
                  BudgetsRoutes,
                  LivretsRoutes,
                  ElevesRoutes,
                  ElevesPreviewRoutes,
                  TrombinoscopeRoutes,
                  PyramidesDesAgesRoutes,
                  RegistreAppelRoutes,
                  PlannerRoutes,
                ],
              },
              RedirectRoutes,
            ],
          },
        ],
      },
      {
        path: '/users/:userId/sequences/:sequenceId/print',
        element: <AutoPrintSequence />,
      },
      {
        path: '/users/:userId/sequences/:sequenceId/fiches-de-prep/:ficheDePrepId/print',
        element: <AutoPrintFicheDePrep />,
      },
      /* OLD SHIT, c'est juste pour les anciens liens sur les PDF
   Car avant une séquence appartenait à 1 user du coup il n'y avait pas de soucis
   pour récupérer les BO labels
   Mais comme maintenant ce n'est plus le cas il faut filer l'info du user
   c'est pour ça qu'il y a la route ☝.
   Mais bon il y plein de PDF qui ont été générés sans le user ID dans l'URL
   Du coup on garde ça pendant 1an et après il y aura prescription, on pourra virer
   */
      {
        path: '/sequences/:sequenceId/fiches-de-prep/:ficheDePrepId/print',
        element: <AutoPrintFicheDePrep />,
      },
      ShareRoutes,
      PrintRoutes,
    ],
  },
];
